import { Stage } from '@/interfaces/stage';
import { EntityResource } from './entity.resource';
import { TypeFilterVariables } from './queryVariables/filters/filters';

/**
 * Resource etapów
 *
 * @export
 * @class StatusResource
 * @extends {EntityResource<Stage>}
 */
export class StageResource extends EntityResource<Stage> {
  public getFields = {
    id: true,
    name: true,
    type: true,
    moduleId: true,
    eventIds: true
  };

  public listFields = {
    id: true,
    name: true,
    type: true
  };

  protected listVariables = TypeFilterVariables;

  constructor() {
    super({
      entityName: 'stage'
    });
  }
}

export const stageResource = new StageResource();
